import * as React from 'react';
import RangePicker from '../RangePicker/RangePicker';

import { SwatchesPicker } from 'react-color';
import { mapStyles } from '../../utils/mapStyles';

interface Props {
  setOpacity: (opacity: string) => void;
  opacity: string;
  setFillColor: (color: string) => void;
  fillColor: string;
  setMapStyle: (style: string) => void;
}

const MapControlls = (props: Props) => {

  const [isPickerShowed, setTogglePicker] = React.useState(false);
  const {
    setOpacity,
    opacity,
    setFillColor,
    fillColor,
    setMapStyle,
  } = props;

  const onTogglePicker = React.useCallback(() => setTogglePicker(!isPickerShowed), [isPickerShowed]);

  const handleColorChange = React.useCallback((color) => {
    setFillColor(color.hex);
    onTogglePicker();
  }, [isPickerShowed]);

  const handleChangeStyle = React.useCallback((e) => {
    setMapStyle(e.target.value);
  }, undefined);

  return (
    <div className='map-control_wrap d-flex justify-center'>
      <div className='d-flex align-center justify-center'>
        <span>{'Polygon opacity: '}</span>
        <RangePicker
          onChangeRange={setOpacity}
          value={opacity} />
      </div>

      <div className='map-style_picker'>
        <select onChange={handleChangeStyle}>
          {
            mapStyles.map((mapStyle) => {
              return (<option
                value={mapStyle.link}
                key={mapStyle.name}>{mapStyle.name}</option>
              );
            })
          }
        </select>
      </div>
      <div className='color-picker'>
        <button onClick={onTogglePicker}>
          <span
            style={{ backgroundColor: fillColor }}
            className='color-indicator' />
        </button>
        <div className='color-picker_container'>
          {
            isPickerShowed && <SwatchesPicker
              height={100}
              width={100}
              onChange={handleColorChange} />
          }
        </div>

      </div>
    </div>
  );
};

export default MapControlls;
